import { STORAGE_USER } from '../../constants';
import UsuariosService from '../../services/UsuariosService';
import { LOGOUT } from '../store-actions';

export const namespaced = true;

export const state = {
  usuario: JSON.parse(localStorage.getItem(STORAGE_USER)),
};

export const mutations = {
  SET_USUARIO(state, usuario) {
    state.usuario = usuario;
    if (usuario) {
      localStorage.setItem(STORAGE_USER, JSON.stringify(usuario));
    } else {
      localStorage.removeItem(STORAGE_USER);
    }
  },
};

export const actions = {
  setUsuario({commit}, usuario) {
    commit('SET_USUARIO', usuario);
  },
  getCurrentUser({commit, dispatch}) {
    UsuariosService.getPerfil().then(r => r.json()).then(
      usuario => {
        commit('SET_USUARIO', usuario);
      }
    ).catch(
      error => {
        if (error.status === 401) {
          dispatch(LOGOUT, null, {root: true});
        }
      }
    );
  },
};

export const getters = {};
